import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useRef,
} from "react";
import { useChecklistDefaults } from "./ChecklistDefaultsContext";
import { useCounty } from "./CountyContext";

const WeatherContext = createContext();

export const WeatherProvider = ({ children }) => {
  const {
    defaultHazard,
    defaultAlertType,
    hasSpecificAlertDefaults,
  } = useChecklistDefaults();
  const { selectedCounty } = useCounty();

  const [weather, setWeather] = useState(
    hasSpecificAlertDefaults ? defaultHazard : "All Hazards"
  );
  const [alertType, setAlertType] = useState(
    hasSpecificAlertDefaults ? defaultAlertType : "Seasonal"
  );

  const weatherTouchedRef = useRef(false);
  const alertTypeTouchedRef = useRef(false);

  useEffect(() => {
    weatherTouchedRef.current = false;
    alertTypeTouchedRef.current = false;
  }, [selectedCounty]);

  useEffect(() => {
    if (weatherTouchedRef.current) return;

    if (hasSpecificAlertDefaults) {
      setWeather(defaultHazard);
    } else {
      setWeather("All Hazards");
    }
  }, [defaultHazard, hasSpecificAlertDefaults, selectedCounty]);

  useEffect(() => {
    if (alertTypeTouchedRef.current) return;

    if (hasSpecificAlertDefaults) {
      setAlertType(defaultAlertType || "Seasonal");
    } else {
      setAlertType("Seasonal");
    }
  }, [defaultAlertType, hasSpecificAlertDefaults, selectedCounty]);

  const updateWeather = (hazard) => {
    weatherTouchedRef.current = true;
    setWeather(hazard);
    alertTypeTouchedRef.current = false;
  };

  const updateAlertType = (type) => {
    alertTypeTouchedRef.current = true;
    setAlertType(type);
  };

  return (
    <WeatherContext.Provider
      value={{ weather, updateWeather, alertType, updateAlertType }}
    >
      {children}
    </WeatherContext.Provider>
  );
};

export const useWeather = () => {
  return useContext(WeatherContext);
};